import { Link } from 'react-router-dom'
import styles from './ServicesOverview.module.css'

const services = [
  { id: '01', title: 'Site Visit' },
  { id: '02', title: 'Calculation of Heat Load' },
  { id: '03', title: 'Planning & Layouting' },
  { id: '04', title: 'Concealing of Refrigerant Pipes' },
  { id: '05', title: 'Pressure Testing' },
  { id: '06', title: 'Final Delivery' },
]

const ServicesOverview = () => {
  return (
    <section className={styles.servicesOverview}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.titleSection}>
            <h2 className={styles.title}>
              Explore Our Top-Notch Range of Services!
            </h2>
          </div>
          <div className={styles.descriptionSection}>
            <p className={styles.description}>
              "With over 14 years of industry experience, we specialize in the design, installation, and maintenance of advanced HVAC systems, ensuring optimal comfort and efficiency for every space."
            </p>
            <Link to="/our-services" className={styles.readMoreBtn}>
              Read More
            </Link>
          </div>
        </div>

        <div className={styles.servicesGrid}>
          {services.map((service) => (
            <div key={service.id} className={styles.serviceCard}>
              <span className={styles.serviceNumber}>{service.id}</span>
              <h3 className={styles.serviceTitle}>{service.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ServicesOverview
